import equal from 'fast-deep-equal';

export const activeProviders = providers =>
  providers.filter(provider => provider.active);

export const compareProviders = (initialProvider, currentProvider) =>
  equal(initialProvider, currentProvider);
